var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { forwardRef } from 'react';
import { CardBody, CardContainer, CardMedia } from './styled';
export const Card = forwardRef((props, forwardedRef) => {
    const { children, media, as, className, border, dropShadow, size } = props, rest = __rest(props, ["children", "media", "as", "className", "border", "dropShadow", "size"]);
    const defaultRatio = 0.45;
    const mediaFraction = Math.min(Math.max(0, defaultRatio), 1);
    return (<CardContainer as={as} className={className} ref={forwardedRef} $dropShadow={dropShadow} $border={border} $size={size} {...rest}>
      {media && <CardMedia $fraction={mediaFraction}>{media}</CardMedia>}
      <CardBody>{children}</CardBody>
    </CardContainer>);
});
